import "../../CommonImports";
import "../../Core/core.css";
import "./Table.css";
import * as React from "react";
/**
 * The DragAndDropGripper is meant to be rendered inside of the
 * spacer column of a table, to indicate an item can be dragged in a table.
 */
export class DragAndDropGripper extends React.Component {
    render() {
        return (React.createElement("div", { className: "bolt-gripper-container bolt-table-cell-content-reveal" },
            React.createElement("div", { className: "bolt-gripper" })));
    }
}
export function renderGripper(index, left) {
    if (left) {
        return React.createElement(DragAndDropGripper, null);
    }
    return null;
}
